export const BookIcon = (props) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width || "55"}
      height={props?.height || "54"}
      fill="none"
      viewBox="0 0 55 54"
    >
      <path
        fill="#1773EA"
        stroke="#64A6FB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.649"
        d="M26.824 2h-20a5 5 0 0 0-5 5v40a5 5 0 0 0 5 5h30a5 5 0 0 0 5-5V17z"
      ></path>
      <path fill="#64A6FB" d="M26.824 2v15h15"></path>
      <path
        stroke="#64A6FB"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3.649"
        d="M26.824 2v15h15"
      ></path>
      <path
        fill="#FFBF9D"
        d="m48.456 45.358 2.826-2.092a.58.58 0 0 1 .816.127l1.66 2.3c.655.887.716 2.392-.505 3.296a2.31 2.31 0 0 1-3.265-.509l-1.659-2.298a.593.593 0 0 1 .127-.824"
      ></path>
      <path
        fill="#FFD733"
        d="m47.758 44.394 2.826-2.092a.595.595 0 0 0 .125-.816l-5.515-7.6-3.816-1.164.934-2.809a.4.4 0 0 0-.144-.141l-4.173-2.773a.59.59 0 0 0-.667.028c-.208.138-.283.413-.227.633l1.35 4.853a.6.6 0 0 0 .101.183l2.695.006.188 3.966 5.514 7.6a.56.56 0 0 0 .809.126"
      ></path>
      <path
        fill="url(#paint0_linear_1948_398)"
        d="m42.31 29.913-3.759 2.782 2.882 3.973 3.76-2.782zm6.835 16.395 3.774-2.792c.754-.556.932-1.706.378-2.468l-4.512-6.204a.58.58 0 0 0-.816-.125.595.595 0 0 0-.125.825l3.47 4.77-4.245 3.133c-.39.29-.629.713-.697 1.161a1.78 1.78 0 0 0 .318 1.319c.573.788 1.674.96 2.456.381m-.364-11.47.004.006zm0 0q-.014-.018 0 0"
      ></path>
      <path
        fill="#fff"
        d="M20.504 36.046q0-1.425.381-2.365.382-.94.916-1.475.534-.534 1.398-1.17.992-.687 1.45-1.271.458-.585.458-1.603 0-1.321-.84-2.009-.84-.686-2.263-.686-1.526 0-2.441.915-.916.89-1.018 2.518h-2.72q.1-1.83.89-3.153a5.3 5.3 0 0 1 2.161-2.035Q20.249 23 21.979 23q2.594 0 4.247 1.373 1.678 1.374 1.678 3.942 0 1.119-.33 1.882-.305.763-.764 1.246a11.4 11.4 0 0 1-1.246 1.043q-.712.534-1.144.966a4.2 4.2 0 0 0-.738 1.043q-.305.635-.356 1.551l-.101.966h-2.721zm1.322 6.943q-.764 0-1.322-.56a1.85 1.85 0 0 1-.534-1.322q0-.738.534-1.272.559-.56 1.322-.56.762 0 1.297.535.56.534.56 1.297 0 .788-.56 1.348a1.77 1.77 0 0 1-1.297.534"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1948_398"
          x1="54.012"
          x2="39.676"
          y1="39.66"
          y2="50.858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F0FD"></stop>
          <stop offset="1" stopColor="#D0D0D0"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
  
  export const DeleteIcon = (props) => (
    <svg
      width={props?.width || "13"}
      height={props?.height || "15"}
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.666626 3.3335H1.96292H12.3333"
        fill="#666666"
      />
      <path
        d="M0.666626 3.3335H1.96292H12.3333"
        stroke="#666666"
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0375 2.66602C11.4053 2.66627 11.7043 2.96512 11.7045 3.33301V12.666C11.7045 13.7527 10.8421 14.6658 9.7406 14.666H3.25916C2.15765 14.6658 1.29626 13.7526 1.29626 12.666V3.33301C1.29644 2.96497 1.59518 2.66602 1.96326 2.66602C2.33119 2.66619 2.63007 2.96508 2.63025 3.33301V12.666C2.63025 13.0519 2.92916 13.3328 3.25916 13.333H9.7406C10.0706 13.3328 10.3705 13.0519 10.3705 12.666V3.33301C10.3707 2.96497 10.6694 2.66602 11.0375 2.66602ZM7.79626 0C8.89774 0.000120074 9.75898 0.913473 9.75916 2V3.33398C9.7588 3.70168 9.46085 3.99969 9.09314 4C8.72517 4 8.4265 3.70187 8.42615 3.33398V2C8.42598 1.61423 8.12624 1.33411 7.79626 1.33398H5.20349C4.87359 1.33421 4.57475 1.6143 4.57458 2V3.33398C4.57423 3.7018 4.27547 3.99988 3.90759 4C3.53962 4 3.24095 3.70187 3.2406 3.33398V2C3.24077 0.913533 4.1021 0.000219751 5.20349 0H7.79626Z"
        fill="#666666"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.20361 6.6665V10.6665V6.6665Z"
        fill="#666666"
      />
      <path
        d="M5.20361 6.6665V10.6665"
        stroke="#666666"
        strokeWidth={0.833333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.79626 6.6665V10.6665V6.6665Z"
        fill="#666666"
      />
      <path
        d="M7.79626 6.6665V10.6665"
        stroke="#666666"
        strokeWidth={0.833333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );